/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { JsonNode } from '../models/json-node';
import { TinVerificationUs } from '../models/tin-verification-us';


/**
 * API to trigger tin verification
 */
@Injectable({
  providedIn: 'root',
})
export class TinVerificationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation verifyTin
   */
  static readonly VerifyTinPath = '/tin-verification/{countryCode}';

  /**
   * Trigger TIN verification for a country.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `verifyTin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verifyTin$Response(params: {
    countryCode: string;
    body: JsonNode
  },
  context?: HttpContext

): Observable<StrictHttpResponse<TinVerificationUs>> {

    const rb = new RequestBuilder(this.rootUrl, TinVerificationService.VerifyTinPath, 'post');
    if (params) {
      rb.path('countryCode', params.countryCode, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TinVerificationUs>;
      })
    );
  }

  /**
   * Trigger TIN verification for a country.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `verifyTin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  verifyTin(params: {
    countryCode: string;
    body: JsonNode
  },
  context?: HttpContext

): Observable<TinVerificationUs> {

    return this.verifyTin$Response(params,context).pipe(
      map((r: StrictHttpResponse<TinVerificationUs>) => r.body as TinVerificationUs)
    );
  }

}
